import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { OUR_OFFICE_LOCATIONS } from "@faire/retailer-visitor-shared/consts/OUR_OFFICE_LOCATIONS";
import { ContentContainer, MOBILE_PADDING, TABLET_PADDING } from "@faire/retailer-visitor-shared/views/about/components/common";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Accordion } from "@faire/web--source/slate/Accordion";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import careers from "@faire/web-api--source/routes/careers";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var CompanyValuesAndOfficesModuleBase = function() {
    var viewport = useViewport();
    var firstImage = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/056b15950a3d73bb4c9383a7ac2780adc956f3442fba8ffd33a5d9716b67ee83.png",
            alt: "Person Smiling While Holding a Cup of Coffee",
            height: 429
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/8f1491772188c44967b86be45e58771d831fb54e3acf60121c274c1361afeafc.png",
            alt: "Person Smiling While Holding a Cup of Coffee",
            height: 643
        }
    });
    var secondImage = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/5ba5ea69abad1da6bb36f5eb0f9e47814a6045e96f34cbfe221ac90d94b78849.png",
            alt: "Lounge With Seating and Plants",
            height: 429
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/63b8f0d7c594636f453c18496921e8b6026a3b20b2ccff947d6cb3e049f33328.png",
            alt: "Lounge With Seating and Plants",
            height: 643
        }
    });
    return /*#__PURE__*/ _jsxs(ContentContainer, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: 72,
                    tabletAndAbove: 96,
                    desktopAndAbove: 120
                }
            }),
            /*#__PURE__*/ _jsx(TopContent, {
                firstImage: firstImage
            }),
            viewport.isTabletAndBelow ? /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: 80,
                    tabletAndAbove: 104
                }
            }) : null,
            /*#__PURE__*/ _jsx(MiddleContent, {
                firstImage: firstImage,
                secondImage: secondImage
            }),
            viewport.isTabletAndBelow ? /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: 72,
                    tabletAndAbove: 96
                }
            }) : null,
            /*#__PURE__*/ _jsx(BottomContent, {
                secondImage: secondImage
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: 120,
                    tabletAndAbove: 104,
                    desktopAndAbove: 176
                }
            })
        ]
    });
};
export var CompanyValuesAndOfficesModule = observer(CompanyValuesAndOfficesModuleBase);
var TopContent = function(param) {
    var firstImage = param.firstImage;
    var viewport = useViewport();
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return viewport.isTabletAndBelow ? /*#__PURE__*/ _jsx(SlideIn, {
        offset: "60px",
        children: /*#__PURE__*/ _jsx(CompanyValuesFAQ, {})
    }) : /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: "60px",
                children: /*#__PURE__*/ _jsx(CompanyValuesFAQ, {})
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: 160
            }),
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: "70px",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: (_optimizeImageUrl = optimizeImageUrl({
                        url: firstImage.src
                    }, isSSR, {
                        height: firstImage.height
                    })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
                    alt: firstImage.alt,
                    height: firstImage.height
                })
            })
        ]
    });
};
var MiddleContent = function(param) {
    var firstImage = param.firstImage, secondImage = param.secondImage;
    var isSSR = useIsSSR();
    var _optimizeImageUrl, _optimizeImageUrl1, _optimizeImageUrl2;
    return useResponsiveValue({
        mobileAndAbove: /*#__PURE__*/ _jsx(ImageContainer, {
            children: /*#__PURE__*/ _jsx(Image, {
                src: (_optimizeImageUrl = optimizeImageUrl({
                    url: firstImage.src
                }, isSSR, {
                    height: firstImage.height
                })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
                alt: firstImage.alt,
                height: firstImage.height
            })
        }),
        tabletAndAbove: /*#__PURE__*/ _jsxs(ImageContainer, {
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: (_optimizeImageUrl1 = optimizeImageUrl({
                        url: secondImage.src
                    }, isSSR, {
                        height: secondImage.height
                    })) !== null && _optimizeImageUrl1 !== void 0 ? _optimizeImageUrl1 : EAEAEA_PIXEL,
                    alt: secondImage.alt,
                    height: secondImage.height
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: 4
                }),
                /*#__PURE__*/ _jsx(Image, {
                    src: (_optimizeImageUrl2 = optimizeImageUrl({
                        url: firstImage.src
                    }, isSSR, {
                        height: firstImage.height
                    })) !== null && _optimizeImageUrl2 !== void 0 ? _optimizeImageUrl2 : EAEAEA_PIXEL,
                    alt: firstImage.alt,
                    height: firstImage.height
                })
            ]
        }),
        desktopAndAbove: /*#__PURE__*/ _jsx(Spacer, {
            height: 104
        })
    });
};
var BottomContent = function(param) {
    var secondImage = param.secondImage;
    var viewport = useViewport();
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return viewport.isTabletAndBelow ? /*#__PURE__*/ _jsx(OurOffices, {}) : /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: "60px",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: (_optimizeImageUrl = optimizeImageUrl({
                        url: secondImage.src
                    }, isSSR, {
                        height: secondImage.height
                    })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
                    alt: secondImage.alt,
                    height: secondImage.height
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: 160
            }),
            /*#__PURE__*/ _jsx(OurOffices, {})
        ]
    });
};
var ImageContainer = styled(Row).withConfig({
    componentId: "sc-9f21085b-0"
})([
    "",
    "{margin:0 -",
    ";}",
    "{margin:0 -",
    ";}"
], responsiveMediaQueries.mobile, MOBILE_PADDING, responsiveMediaQueries.tablet, TABLET_PADDING);
var OurOffices = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: "60px",
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "displayMSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "AiJZfH",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Our offices"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "6x"
            }),
            /*#__PURE__*/ _jsxs(SlideIn, {
                offset: "70px",
                children: [
                    /*#__PURE__*/ _jsx(StyledRow, {
                        children: OUR_OFFICE_LOCATIONS.map(function(value, index) {
                            return /*#__PURE__*/ _jsx(OfficeLocation, {
                                children: value
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsxs(JoinUsContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subheadingSansRegular",
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "cuPIF2",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Interested in joining us?"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "1x"
                            }),
                            /*#__PURE__*/ _jsxs(LinkContainer, {
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "tertiary",
                                        linkTo: careers(),
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subheadingSansRegular",
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "seykJa",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Careers at Faire"
                                                    }
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: "1x"
                                    }),
                                    /*#__PURE__*/ _jsx(ArrowContainer, {
                                        children: /*#__PURE__*/ _jsx(Arrow, {
                                            direction: "right"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CompanyValuesFAQ = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(Accordion, {
        title: strictLocalize({
            id: "Pqudcw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Company values"
                }
            ]
        }),
        titleAlignment: "left",
        items: COMPANY_VALUES(strictLocalize),
        initiallyOpenIndex: 0
    });
};
var COMPANY_VALUES = function(strictLocalize) {
    return [
        {
            question: strictLocalize({
                id: "Ww2Wr9",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Serve our community"
                    }
                ]
            }),
            answer: strictLocalize({
                id: "2VAerx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Our work always starts with the mission. We\u2019re motivated every day to help our customers succeed against competitors a million times their size, and we fight hard to help level the playing field."
                    }
                ]
            })
        },
        {
            question: strictLocalize({
                id: "ZabcTC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Seek the truth"
                    }
                ]
            }),
            answer: strictLocalize({
                id: "QdPC8i",
                defaultMessage: [
                    {
                        type: 0,
                        value: "We care deeply about getting to the right answer, and always dig to the root. We approach questions with an open, growth mindset, and are radically transparent when it comes to sharing the results we uncover."
                    }
                ]
            })
        },
        {
            question: strictLocalize({
                id: "fc3g0q",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Be an owner"
                    }
                ]
            }),
            answer: strictLocalize({
                id: "eFBd7P",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Each of us brings a founder\u2019s mindset to our work\u2014we\u2019re relentlessly resourceful, we raise the bar on quality, and we care less about the scope of our role than we do about ensuring the best work gets done."
                    }
                ]
            })
        },
        {
            question: strictLocalize({
                id: "NVZRRO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Embrace the adventure"
                    }
                ]
            }),
            answer: strictLocalize({
                id: "rg2uq0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "We love nothing more than taking the big risk and daring greatly. We\u2019re resilient through change, have a bias towards action, and always find time to laugh, celebrate, and enjoy the ride."
                    }
                ]
            })
        },
        {
            question: strictLocalize({
                id: "08Fuse",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Be kind"
                    }
                ]
            }),
            answer: strictLocalize({
                id: "nUzU3m",
                defaultMessage: [
                    {
                        type: 0,
                        value: "We don\u2019t shy away from direct feedback and conversation, because we always assume good intent. We\u2019re eager to help our teammates, share openly, and celebrate diverse perspectives."
                    }
                ]
            })
        }
    ];
};
var StyledRow = styled(Row).withConfig({
    componentId: "sc-9f21085b-1"
})([
    "flex-wrap:wrap;"
]);
var OfficeLocation = styled(Typography).attrs({
    variant: "sectionHeaderSansMedium"
}).withConfig({
    componentId: "sc-9f21085b-2"
})([
    "&&&{width:50%;margin-bottom:24px;}"
]);
var JoinUsContainer = styled.div.withConfig({
    componentId: "sc-9f21085b-3"
})([
    "display:flex;",
    "{flex-direction:column;}"
], responsiveMediaQueries.mobile);
var ArrowContainer = styled.div.withConfig({
    componentId: "sc-9f21085b-4"
})([
    "transition:0.5s ease;"
]);
var LinkContainer = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-9f21085b-5"
})([
    "&:hover{",
    "{transform:translate(10px);}}"
], ArrowContainer);
var Image = styled.img.withConfig({
    componentId: "sc-9f21085b-6"
})([
    "display:block;width:100%;object-fit:cover;",
    "{width:528px;}"
], responsiveMediaQueries.desktopAndAbove);
